//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransferenciaPosseForm from './TransferenciaPosseForm';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import TransferenciaPosseDefinitiva from './definitiva/TransferenciaPosseDefinitiva';

export default {
  name: 'TransferenciaPosseAbas',
  components: {
    TransferenciaPosseForm,
    Confirm,
    TransferenciaPosseDefinitiva,
  },
  props: {},
  data() {
    return {
      tabSelecionada: null,
      canAccessPage: true,
      dialogForm: false,
      esperar: false,
      posse: {},
      possesTemporarias: [],
      historicoPosses: [],
      resources: this.$api.transferenciaPosse(this.$resource),
      paginationTemporaria: {
        totalPage: 0,
      },
      paginationHistorico: {
        totalPage: 0,
      },
      posseSelecionada: null,
      searchQueryTemporaria: '',
      searchQueryHistorico: '',
      totalPage: 0,
      alturaTela: screen.height,
      headersPossesTemporarias: [
        { text: this.$tc('label.de', 2), value: 'de' },
        { text: this.$tc('label.para', 1), value: 'para' },
        { text: this.$tc('label.motivo', 1), value: 'motivo' },
        { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false },
        { text: '', value: 'opcao', sortable: false },
      ],
      headersHistoricoPosses: [
        { text: this.$tc('label.de', 2), value: 'de' },
        { text: this.$tc('label.para', 1), value: 'para' },
        { text: this.$tc('label.motivo', 1), value: 'motivo' },
        { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false },
        { text: this.$tc('label.data_fim', 1), value: 'dtaEncerrado', sortable: false },
      ],
      rules: {
        validDate: value => this.isDataValida(value) || this.$t('message.data_invalida'),
      },
    };
  },
  watch: {
    searchQueryTemporaria() {
      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(() => {
        this.buscarPossesTemporarias();
      }, 500);
    },
    searchQueryHistorico() {
      if (this.timeoutHist) {
        window.clearTimeout(this.timeoutHist);
      }
      this.timeoutHist = window.setTimeout(() => {
        this.buscarHistoricoPosses();
      }, 500);
    },
    paginationTemporaria: {
      handler() {
        this.buscarPossesTemporarias();
      },
      deep: true,
    },
    paginationHistorico: {
      handler() {
        this.buscarHistoricoPosses();
      },
      deep: true,
    },
  },
  methods: {
    abrirForm() {
      this.dialogForm = true;
    },
    abrirDialogRemover(item) {
      this.posseSelecionada = item;
      this.$refs.confirmDialog.open();
    },
    buscarPossesTemporarias() {
      const params = {
        nome: this.search,
        numeroPagina: this.paginationTemporaria.page || 1,
        tamanhoPagina: this.paginationTemporaria.itemsPerPage || 10,
        asc: !this.paginationTemporaria.sortDesc[0],
        colunaOrdenacao: this.paginationTemporaria.sortBy[0] || '',
        filtro: this.searchQueryTemporaria,
      };

      this.resources.listarTemporarios(params).then((response) => {
        this.possesTemporarias = response.data.resposta;
        this.paginationTemporaria.totalPage = response.data.quantidadeRegistrosPagina;
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscarHistoricoPosses() {
      const params = {
        nome: this.search,
        numeroPagina: this.paginationHistorico.page || 1,
        tamanhoPagina: this.paginationHistorico.itemsPerPage || 10,
        asc: !this.paginationHistorico.sortDesc[0],
        colunaOrdenacao: this.paginationHistorico.sortBy[0] || '',
        filtro: this.searchQueryHistorico,
      };

      this.resources.listarHistorico(params).then((response) => {
        this.historicoPosses = response.data.resposta;
        this.paginationHistorico.totalPage = response.data.quantidadeRegistrosPagina;
      }, (err) => {
        this.$error(this, err);
      });
    },
    carregarGrids() {
      this.dialogForm = false;
      this.buscarHistoricoPosses();
      this.buscarPossesTemporarias();
    },
    fecharForm() {
      this.idEvento = null;
      this.dialogForm = false;
    },
    removerTransferenciaTemporaria() {
      this.resources.remover(this.posseSelecionada.idControladorTrade).then(() => {
        this.carregarGrids();
      }, (err) => {
        this.$error(this, err);
      });
    },
  },
  beforeMount() {
    if (this.canAccessPage) {
      this.headersPossesTemporarias.push({ text: '', value: 'acao', sortable: false });
    }
  },
  mounted() {
    this.carregarGrids();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/TransferenciaPosseAbas.vue?vue&type=script&lang=js&